/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_SettlementConfiguration_SaveSettlementConfigurationDto } from '../models/Wealthlane_AwardService_Dtos_SettlementConfiguration_SaveSettlementConfigurationDto';
import type { Wealthlane_AwardService_Dtos_SettlementConfiguration_SettlementConfigurationDefaultDto } from '../models/Wealthlane_AwardService_Dtos_SettlementConfiguration_SettlementConfigurationDefaultDto';
import type { Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_SettlementConfigurationSharedDto } from '../models/Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_SettlementConfigurationSharedDto';
import type { Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_UpsertSettlementConfigurationDto } from '../models/Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_UpsertSettlementConfigurationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SettlementConfigurationService {

    /**
     * @param referenceId 
     * @param referenceType 
     * @returns Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_SettlementConfigurationSharedDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppSettlementConfigurationByReference(
referenceId: string,
referenceType?: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_SettlementConfigurationSharedDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/settlement-configuration/by-reference/{referenceId}',
            path: {
                'referenceId': referenceId,
            },
            query: {
                'referenceType': referenceType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_SettlementConfiguration_SettlementConfigurationDefaultDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppSettlementConfigurationDefaultSettlementConfiguration(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_SettlementConfiguration_SettlementConfigurationDefaultDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/settlement-configuration/default-settlement-configuration',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardService_Dtos_SettlementConfiguration_SettlementConfigurationDefaultDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppSettlementConfigurationUpsertDefaultSettlementConfiguration(
requestBody?: Wealthlane_AwardService_Dtos_SettlementConfiguration_SaveSettlementConfigurationDto,
): CancelablePromise<Wealthlane_AwardService_Dtos_SettlementConfiguration_SettlementConfigurationDefaultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/settlement-configuration/upsert-default-settlement-configuration',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyId 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppSettlementConfigurationSettlementConfigurationForServices(
companyId: string,
requestBody?: Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_UpsertSettlementConfigurationDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/settlement-configuration/settlement-configuration-for-services/{companyId}',
            path: {
                'companyId': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param settlementConfigurationId 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAwardApiAppSettlementConfigurationSettlementConfiguration(
settlementConfigurationId: string,
requestBody?: Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_UpsertSettlementConfigurationDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/settlement-configuration/settlement-configuration/{settlementConfigurationId}',
            path: {
                'settlementConfigurationId': settlementConfigurationId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param settlementTypeId 
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppSettlementConfigurationUpsertSettlementConfiguration(
settlementTypeId: string,
requestBody?: Wealthlane_Shared_Hosting_Dtos_SettlementConfigurationDto_UpsertSettlementConfigurationDto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/settlement-configuration/upsert-settlement-configuration/{settlementTypeId}',
            path: {
                'settlementTypeId': settlementTypeId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
